import React from "react";

/*
 * Custom fonts
 * Uncomment below if using custom fonts
 */

import "./static/fonts/fonts.css";
import "lenis/dist/lenis.css";
import Lenis from "lenis";

let lenis;

function mountLenis() {
  if (typeof window === "undefined") return;
  if (lenis && typeof lenis.destroy === "function") {
    lenis.destroy();
  }
  lenis = undefined;

  const wrapper = document.querySelector(".full-page-scroll");
  const content = document.querySelector("[data-lenis-content]");

  const options = {
    autoRaf: true,
    anchors: true,
    allowNestedScroll: true,
  };

  if (wrapper && content) {
    lenis = new Lenis({
      ...options,
      wrapper,
      content,
    });
  } else {
    lenis = new Lenis(options);
  }
}

export const onClientEntry = () => {
  mountLenis();
  /* Last resort if SSR boot veil is still present (e.g. hydration/runtime failure). */
  if (typeof window !== "undefined") {
    window.setTimeout(() => {
      try {
        const { removePageRevealBootVeil } = require("./src/shared/pageRevealOverlay");
        removePageRevealBootVeil();
      } catch {
        /* ignore */
      }
    }, 5000);
  }
};

export const onRouteUpdate = () => {
  mountLenis();
};

export function wrapPageElement({ element, props }) {
  return <div>{element}</div>;
}
